"use client";

import { create } from "zustand";
import { createSelectors } from "./createSelectors";

import { createAuthSlice, type AuthSlice } from "./slices/auth.slice";
import {
  createParticipantFlowSlice,
  type ParticipantFlowSlice,
} from "./slices/participantFlow.slice";
import { createSessionSlice, type SessionSlice } from "./slices/session.slice";

export type StoreState = AuthSlice & SessionSlice & ParticipantFlowSlice;

export const useBoundStore = create<StoreState>()((...a) => ({
  ...createAuthSlice(...a),
  ...createParticipantFlowSlice(...a),
  ...createSessionSlice(...a),
}));

export const useStore = createSelectors(useBoundStore);
